/**
 * Pre-compiled en messages for Calendar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  nextMonth: `Next month`,
  nextYear: `Next year`,
  previousMonth: `Previous month`,
  previousYear: `Previous year`,
};
